<template>
    <div class="fixed left-0 right-0 top-0 bottom-0 bg-[#0005] z-[1049]"></div>
    <div class="fixed left-0 top-0 w-full h-full flex justify-center items-center z-[1050] p-2">
        <div class="bg-[#FFF] rounded-lg p-6">
            <div class="flex flex-col justify-center items-center">
                <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_BASE_PATH}Loader.gif`" class="w-20 h-20 mix-blend-multiply contrast-100" />
                <div v-if="titleToDisplay || title" class="font-bold text-base text-[#2E2E2E]">{{ titleToDisplay || title  }}</div>
                <div v-if="messageToDisplay || message" class="font-normal text-sm text-[#2E2E2E]">{{ messageToDisplay || message  }}</div>
            </div>
        </div>
    </div>
</template> 

<script setup>
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_BASE_PATH } from "@/config/constants"
import { onMounted, ref } from "vue";

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    message: {
        type: String,
        default: ''
    },
    titles: {
        type: Array,
        default: []
    },
    messages: {
        type: Array,
        default: []
    }
});

// This code block is setting up a mechanism to cycle through an array of titles provided as a prop
// (`props.titles`) and display them one by one at a time with a delay of 2000 milliseconds between
// each title.
const titleToDisplay = ref('');
const titleIndex = ref(0)
const showNextTitle = () => {
    if (titleIndex.value < props.titles.length) {
        titleToDisplay.value = props.titles[titleIndex.value++];
        setTimeout(showNextTitle, 2000)
    }
}

// This code block is setting up a mechanism to cycle through an array of messages provided as a prop
// (`props.messages`) and display them one by one at a time with a delay of 2000 milliseconds between
// each message.
const messageToDisplay = ref('');
const messageIndex = ref(0)
const showNextMessage = () => {
    if (messageIndex.value < props.messages.length) {
        messageToDisplay.value = props.messages[messageIndex.value++];
        setTimeout(showNextMessage, 2000)
    }
}

onMounted(() => {
    if ( props.messages.length ) {
        showNextMessage();
    }
    if ( props.titles.length ) {
        showNextTitle();
    }
});
</script>